import Comp from './DataRouter'

export default Comp
